
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    ACTIVATE_CAMERA_SIM_CARD_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { activateCameraSimCardResult } from 'Redux/actions';
import { clientPOST } from 'Core/data/RestApi';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';

function* activateCamerasSimCard({ payload }) {
    let devicesResponse = [];
    try {
        const headers = {
            'Content-Type': 'application/json'
        };
        let devices = payload || [];
        if (devices.length > 0) {
            for (let index = 0; index < devices.length; index++) {
                let device = devices[index];
                try {
                    let id = device?.id;
                    try {

                        let QUERY = `
                            mutation updateVidFleetActivateSimCard ($unitId: Int!) {
                               result: updateVidFleetActivateSimCard (unitId: $unitId)
                            }
                        `;

                        let result = yield call(
                            clientMutation,
                            QUERY,
                            {
                                unitId: id
                            },
                            endpoints.GRAPHQL_GENERAL,
                        );
                        devicesResponse.push({ esn: device.esn, status: result?.result ? 200 : 400, message: result?.result ? "Activated" : "Cannot be activated" });

                    } catch (exc) {
                        if (exc?.response) {
                            devicesResponse.push({ esn: device.esn, status: exc?.request?.status, message: exc?.response?.data?.msg })
                        }
                    }
                } catch (exc) { }
            }
        }
        yield put(activateCameraSimCardResult(devicesResponse));

    } catch (exc) {
        yield put(bulkActionsSearchDevicesResult([]))
        ExceptionManager(
            exc,
            "Modules/devices/.components/activateSimCard/redux/saga.js",
            "activateCamerasSimCard",
        )
    }
}

function* watchMethods() {
    yield takeEvery(ACTIVATE_CAMERA_SIM_CARD_REQUEST, activateCamerasSimCard);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}